<template>
  <template v-if="this.clickToSelect">
    <label for="tickwidget-fileUpload">
      <div class="drop-zone" :class="{ active: this.active }" :data-active="active" @dragenter.prevent="setActive" @dragover.prevent="setActive" @dragleave.prevent="setInactive"
        @drop.prevent="this.onDrop">
        <slot :dropZoneActive="active"></slot>
      </div>
      <input id="tickwidget-fileUpload" class="upload-button" type="file" multiple @change="this.onInputChange" />
    </label>
  </template>

  <template v-else>
    <div class="cw-drop-zone" :class="{ active: this.active }" :data-active="active" @dragenter.prevent="setActive" @dragover.prevent="setActive" @dragleave.prevent="setInactive"
      @drop.prevent="this.onDrop">
      <slot :dropZoneActive="active"></slot>
    </div>
    <input id="tickwidget-fileUpload" class="cw-upload-button" type="file" multiple @change="this.onInputChange" />
  </template>
</template>

<script lang="ts">
import { ref } from 'vue';
import { Component, Prop, Vue } from 'vue-facing-decorator';


@Component({
  emits: ["dropped"],
  components: {},
})
export default class FileDropZone extends Vue {
  @Prop() private clickToSelect: boolean;

  active = false;
  inActiveTimeout = null //hold the timeout key


  private onDrop(e) {
    this.setInactive() // add this line too
    this.addFiles([...e.dataTransfer.files]);
  }

  private addFiles(files) {
    this.$emit('dropped', files)
  }

  setActive() {
    this.active = true
    clearTimeout(this.inActiveTimeout)
  }
  setInactive() {

    // wrap it in a `setTimeout`
    this.inActiveTimeout = setTimeout(() => {
      this.active = false
    }, 50)
  }


  private preventDefaults(e) {
    e.preventDefault()
  }

  private onInputChange(e) {
    this.addFiles(e.target.files)
    e.target.value = null
  }

  events = ['dragenter', 'dragover', 'dragleave', 'drop']

  mounted() {

    this.events.forEach((eventName) => {
      document.body.addEventListener(eventName, this.preventDefaults)
    })

  }

  unounted() {

    this.events.forEach((eventName) => {
      document.body.removeEventListener(eventName, this.preventDefaults)
    })

  }

}
</script>

<style lang="scss" scoped>
@import "@/styles/theme";

.cw-upload-button {
  display: none;
}

.cw-drop-zone {
  height: 100%;
  width: 100%;
  //border: dotted 1px $grey400;


  &.active {
    background-color: $grey200;
  }

  .drop-message {
    color: $grey600;
    padding-top: 5px;
    text-align: center;
  }


}
</style>
